import LoginPage from '../../components/pages/login/LoginPage'

export const loginRootPages = {
  path: '/connect',
  name: 'login',
  component: LoginPage
}
